import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostExternalIntegrationMainSettingsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			integrationProvider,
			mainSettings,
		}: {
			integrationProvider: Api.IntegrationProvider;
			mainSettings: Partial<Api.IIntegrationSettings>;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/settings`,
				}),
				'POST',
				{
					...mainSettings,
					_type: `${integrationProvider}IntegrationSettings`,
				}
			);
		},
		onError,
		onSuccess,
	});
};
